module.exports = "<div>Logging out, please wait...</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/logout/custom-logout.component.html
// module id = ./src/app/pages/logout/custom-logout.component.html
// module chunks = main